import {SSX_AVATAR_IDS} from './ssx-avatar-presets.mjs';
// Appearance assets are public to render other players. Selection is a separate,
// server-authorized capability derived only from the bound canonical identity.
export const PUBLIC_AVATAR_PRESETS=Object.freeze(['female','male',...SSX_AVATAR_IDS]);
export const PERSONAL_AVATAR_PRESET='valor';
export const PERSONAL_AVATAR_ASSET_READY=true;
export function allowedAvatarPresets(identity,data={}){
 const owner=data.cosmeticOwner?.accountId;
 return PERSONAL_AVATAR_ASSET_READY&&identity?.kind==='authenticated'&&typeof owner==='string'&&/^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(owner)&&owner===identity.id
  ?[...PUBLIC_AVATAR_PRESETS,PERSONAL_AVATAR_PRESET]:[...PUBLIC_AVATAR_PRESETS];
}

